export default "__VITE_ASSET__DngRadTi__"